import { adminHttpClient } from '../../../../commons/adminHttpClient'

export interface SelectClassValues {
  classType: number | null
  productClassId: string | null
  planPeriodId?: string
}

export enum ClassType {
  FullTime = 1,
  PartTime = 2,
  Salaried = 3,
  Hourly = 4,
  Executive = 5,
  Manager = 6,
  Staff = 7,
  AllEligibleEmployees = 8,
}

export enum ClassTypeText {
  FullTime = 'Full-time',
  PartTime = 'Part-time',
  Salaried = 'Salaried',
  Hourly = 'Hourly',
  Executive = 'Executive',
  Manager = 'Manager',
  Staff = 'Staff',
  AllEligibleEmployees = 'All eligible employees',
}

const selectClassApi = (selectClassValues: SelectClassValues): Promise<any> => {
  return adminHttpClient.put('/AdminDashboard/ClassDesign/SelectClass', selectClassValues)
}

export default selectClassApi
